import ListItemLabel from './list-item-label';

export default ListItemLabel;